<div class="training-program-analytics-page">
	<div class="training-program-analytics-page__shell">

		<loader-overlay *ngIf="!vm.initialized"></loader-overlay>

		<div *ngIf="vm.initialized && !vm.error" class="training-program-analytics-page__content">
			<div class="training-program-analytics-page__analytics-grid">
				<section>
                    <div class="training-program-analytics-page__header">
                        <h1 class="training-program-analytics-page__title">{{ vm.getProgramTitle() }}</h1>
                        <a routerLink="/training-programs" class="training-program-analytics-page__back-link">
                            {{ 'Training.Analytics.Back_To_Programs' | translate }}
                        </a>
                    </div>

					<div class="training-program-analytics-page__section-title">{{ 'Training.Analytics.Overview' | translate }}</div>
					<div *ngIf="!vm.showNoContentMessage" class="training-program-analytics-page__chart-panel">
						<div class="training-program-analytics-page__chart">
							<ng-google-charts [data]="vm.pieChartOptions"></ng-google-charts>
						</div>
						<div class="training-program-analytics-page__legend">
							<div *ngFor="let item of legendItems" class="training-program-analytics-page__legend-item">
								<div class="training-program-analytics-page__legend-label-wrap">
									<span class="training-program-analytics-page__legend-color" [style.background-color]="item.color"></span>
									<span>{{ item.label }}</span>
								</div>
								<div class="training-program-analytics-page__legend-value">{{ item.value }} ({{ item.percentage }}%)</div>
							</div>
						</div>
					</div>
					<div *ngIf="vm.showNoContentMessage" class="training-program-analytics-page__empty">
						{{ 'Training.Analytics.No_Content' | translate }}
					</div>
				</section>
			</div>

			<section>
				<div class="training-program-analytics-page__section-header">
					<div>
						<div class="training-program-analytics-page__section-title">{{ 'Training.Analytics.Learners' | translate }}</div>
						<div class="training-program-analytics-page__section-subtitle">{{ vm.getAssignedLearnersCount() }} {{ 'Training.Analytics.Assigned_Learners' | translate }}</div>
					</div>
                </div>

				<div class="training-program-analytics-page__filters" *ngIf="vm.learners?.length">
					<div class="training-program-analytics-page__filter-field">
						<label class="training-program-analytics-page__filter-label" for="learnerStatusFilter">{{ 'Training.Analytics.Status' | translate }}</label>
						<select
							id="learnerStatusFilter"
							class="training-program-analytics-page__filter-control"
							[(ngModel)]="vm.filters.status"
							(ngModelChange)="vm.applyLearnerFilters()">
							<option *ngFor="let status of vm.statusOptions" [ngValue]="status">
								{{ vm.getStatusOptionLabel(status) }}
							</option>
						</select>
					</div>
					<div class="training-program-analytics-page__filter-field">
						<label class="training-program-analytics-page__filter-label" for="learnerGroupFilter">{{ 'Training.Analytics.Group_Tag' | translate }}</label>
						<select
							id="learnerGroupFilter"
							class="training-program-analytics-page__filter-control"
							[(ngModel)]="vm.filters.group"
							(ngModelChange)="vm.applyLearnerFilters()">
							<option *ngFor="let group of vm.groupOptions" [ngValue]="group">
								{{ group === 'all' ? ('Training.Analytics.Filter_All_Groups' | translate) : group }}
							</option>
						</select>
					</div>
					<div class="training-program-analytics-page__filter-field training-program-analytics-page__filter-field--search">
						<label class="training-program-analytics-page__filter-label" for="learnerSearchFilter">{{ 'Training.Analytics.Search_By_Name' | translate }}</label>
						<input
							id="learnerSearchFilter"
							type="text"
							class="training-program-analytics-page__filter-control"
							[(ngModel)]="vm.filters.search"
							(input)="vm.applyLearnerFilters()"
							[placeholder]="'Training.Analytics.Search_Placeholder' | translate">
					</div>
				</div>

				<div class="training-program-analytics-page__table-wrap" *ngIf="vm.filteredLearners?.length">
					<table class="training-program-analytics-page__table">
						<thead>
							<tr>
								<th>{{ 'Training.Analytics.Learner_Name' | translate }}</th>
								<th>{{ 'Training.Analytics.Group_Tag' | translate }}</th>
								<th>{{ 'Training.Analytics.Modules_Progress' | translate }}</th>
								<th>{{ 'Training.Analytics.Average_Score' | translate }}</th>
								<th>{{ 'Training.Analytics.Status' | translate }}</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let learner of vm.filteredLearners">
								<td class="training-program-analytics-page__learner-name">{{ learner.name || '-' }}</td>
								<td>{{ learner.groupOrTag }}</td>
								<td>
									<div class="progress-bar-cell">
										<div class="progress-track">
											<div class="progress-fill" [style.width.%]="learner.progressPercent"></div>
										</div>
										{{ learner.modulesProgress }} ({{ learner.progressPercent }}%)
									</div>
								</td>
								<td>{{ learner.avgScoreDisplay }}</td>
								<td>
									<span class="training-program-analytics-page__badge" [ngClass]="vm.getLearnerStatusClass(learner.statusKey)">
										{{ learner.statusLabel }}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div *ngIf="!vm.filteredLearners?.length" class="training-program-analytics-page__empty">
					{{ 'Training.Analytics.No_Content' | translate }}
				</div>
			</section>
		</div>

		<div *ngIf="vm.initialized && vm.error" class="training-program-analytics-page__empty">
			{{ 'Training.Analytics.No_Content' | translate }}
		</div>
	</div>
</div>
